angular
    .module("skillBuilderSaaS")
    .factory("storageService", ["$localStorage", function ($localStorage) {
        return $localStorage;
    }]);
